import React from 'react';
import { Button } from '@seeqdev/qomponents';
import { Instance } from 'flatpickr/dist/types/instance';
import { createRoot, Root } from 'react-dom/client';

const FOOTER_CSS_CLASS = 'flatpickr-footer';

const hasFooter = (instance: Instance): boolean => {
  return !!instance.calendarContainer.querySelector(`.${FOOTER_CSS_CLASS}`);
};

const renderReactButton = (children: React.ReactNode) => {
  const el: HTMLDivElement = document.createElement('div');
  const root: Root = createRoot(el);
  root.render(children);
  return [root, el] as [Root, HTMLDivElement];
};

export const createFooterButtons = (instance: Instance, t: (key: string) => string, onCancel: () => void) => {
  if (hasFooter(instance)) return null;

  const footer = document.createElement('div');
  footer.classList.add(FOOTER_CSS_CLASS);

  const [cancelRoot, cancelContainer] = renderReactButton(
    <Button onClick={onCancel} label={t('CANCEL')} extraClassNames="sq-btn-xs flatpickr-cancel-button" />,
  );
  const [doneRoot, doneContainer] = renderReactButton(
    <Button
      onClick={() => instance.close()}
      label={t('DONE')}
      variant="theme"
      extraClassNames="sq-btn-xs ml-1 flatpickr-done-button"
    />,
  );

  footer.appendChild(cancelContainer);
  footer.appendChild(doneContainer);
  instance.calendarContainer.appendChild(footer);

  return () => {
    try {
      cancelRoot.unmount();
      doneRoot.unmount();
    } catch (error) {
      console.warn('Error unmounting flatpickr footer buttons:', error);
    }

    // Ensure DOM cleanup even if React unmount fails
    if (footer.parentNode) {
      footer.remove();
    }
  };
};
